module.exports = __webpack_public_path__ + "img/20180815_151629_190.4edd7623.jpg";